import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr0124',
    ecrans: ['00-2']
});
